let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lezCZ")).then(() => parcelRequire('bTYDr'));